var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterpayPaymentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7902 0H4.20978C1.88478 0 0 1.88478 0 4.20978V25.7902C0 28.1152 1.88478 30 4.20978 30H25.7902C28.1152 30 30 28.1152 30 25.7902V4.20978C30 1.88478 28.1152 0 25.7902 0Z",
    fill: "#B2FCE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3829 5.26063C17.0387 5.21379 17.4725 5.36247 18.0591 5.62723C20.3666 6.67 22.7026 8.41949 24.9878 9.57835C26.7189 11.1099 26.4033 13.1058 24.5112 14.3299C22.7556 15.4643 20.1609 16.9063 18.279 17.8329C16.3483 18.7841 14.0183 18.1894 13.7271 15.8614C13.6558 15.2912 13.9206 14.5335 13.1079 14.3767L6.89002 17.8085C6.60896 18.1344 6.72912 18.5539 7.10591 18.7535L12.9389 21.9938C14.3198 22.1975 13.2383 20.1894 14.1079 19.9531C14.4196 19.8676 15.8656 20.6761 16.0733 20.9572C16.5927 21.6578 16.167 22.9898 15.6762 23.6232C14.7373 24.839 13.2994 25.0081 11.943 24.4113C9.63748 23.3971 7.26477 21.5274 4.94705 20.4317C3.5499 19.2953 3.51731 17.2708 4.85336 16.061C6.97149 14.8879 9.0387 13.5906 11.1792 12.4623C11.5906 12.2443 12.1507 11.8696 12.5743 11.7576C14.1507 11.3482 15.8208 12.279 16.1833 13.8859C16.3279 14.5234 16.0855 15.6313 16.9267 15.6293L23.0448 12.1995C23.279 11.9612 23.22 11.5071 22.9857 11.2912L17.169 8.04067C15.5499 7.54373 17.0204 10.5254 15.4725 10.0223C15.055 9.88589 13.8126 9.15676 13.7312 8.7087C13.4155 6.97957 14.6436 5.38691 16.3809 5.26063H16.3829Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterpayPaymentImage);
export default __webpack_public_path__ + "static/media/afterpay-payment-image.0a6c301d1461770e2d1c1b6cffda74c3.svg";
export { ForwardRef as ReactComponent };